import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Slide,
  Stack,
  Typography,
  useScrollTrigger
} from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { LangContext } from '../index';
import { useTranslation } from '../../i18n';

export const FixedCTA: React.FC = () => {
  const navigate = useNavigate();
  const { lang } = useContext(LangContext);
  const { t } = useTranslation(lang);
  const trigger = useScrollTrigger({
    threshold: 100
  });

  return (
    <Slide direction="up" in={trigger}>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          bgcolor: 'rgba(0, 0, 0, 0.8)',
          backdropFilter: 'blur(8px)',
          py: 2,
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          zIndex: 10
        }}
      >
        <Container
          maxWidth="lg"
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}
        >
          <Stack alignItems="center" spacing={0.3} sx={{ display: { xs: 'none', sm: 'flex' } }}>
            <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Offre de lancement
            </Typography>
            <Typography sx={{ color: '#FFD700', fontWeight: 700, fontSize: '0.85rem' }}>
              -50% sur l’abonnement annuel
            </Typography>
          </Stack>
          <Button
            variant="contained"
            size="large"
            startIcon={<RocketLaunchIcon />}
            onClick={() => navigate('/signup')}
            sx={{
              bgcolor: '#2e7d32',
              '&:hover': { bgcolor: '#1b5e20' },
              px: 4,
              py: 1.2,
              fontWeight: 700,
              fontSize: '1rem',
              textTransform: 'none',
              borderRadius: 2,
              boxShadow: '0 0 20px rgba(46,125,50,0.4)',
            }}
          >
            Découvrir TacticaFoot
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={() => {
              const el = document.getElementById('pricing');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
              else navigate('/?section=pricing');
            }}
            sx={{
              borderColor: 'rgba(255,255,255,0.3)',
              color: 'rgba(255,255,255,0.8)',
              '&:hover': { borderColor: 'white', bgcolor: 'rgba(255,255,255,0.08)' },
              px: 3,
              textTransform: 'none',
            }}
          >
            Voir les tarifs
          </Button>
        </Container>
      </Box>
    </Slide>
  );
};
